import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import Button from 'flarum/common/components/Button';
import PaymentOptionsModal from './PaymentOptionsModal';
export default class SubscribeCard extends Component {
  actor = app?.session?.user;
  oninit(vnode) {
    super.oninit(vnode);
    this.group = this.attrs.group;
  }
  view() {
    return m("div", {
      className: "SubscribeCard",
      style: this.group.color() ? {
        backgroundColor: this.group.color()
      } : ''
    }, m("span", {
      className: "icon"
    }, m(Icon, {
      name: this.group.icon() || ''
    })), m("h2", {
      className: "group"
    }, this.group.namePlural()), m("div", {
      className: "description"
    }, this.group.product?.attributes.description), m("div", {
      className: "controls"
    }, this.button()));
  }
  button() {
    const actorGroups = this.actor?.groups() || [];
    const inGroup = actorGroups.find(group => {
      return group.id() === this.group.id();
    }) !== undefined;
    return Button.component({
      icon: inGroup ? 'fas fa-users' : 'fas fa-shopping-cart',
      className: 'Button',
      onclick: () => app.modal.show(PaymentOptionsModal, {
        for: this.group,
        product: this.group.product
      }),
      disabled: inGroup
    }, inGroup ? app.translator.trans('floxum-payments.forum.access-portal.subscribed') : app.translator.trans('floxum-payments.forum.access-portal.options'));
  }
}
flarum.reg.add('floxum-payments', 'forum/Groups/SubscribeCard', SubscribeCard);